import { useState, type FormEvent } from 'react'
import { toast } from 'sonner'
import { useAuthStore } from '@/stores/auth'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent } from '@/components/ui/card'
import { ThemeToggle } from '@/components/ThemeToggle'

/**
 * LoginPage premium (F6) — card centrada con hero brand a la izquierda
 * (en pantallas grandes) y formulario a la derecha. Sobrio, sin emojis.
 */
export function LoginPage() {
  const login = useAuthStore((s) => s.login)
  const loading = useAuthStore((s) => s.loading)
  const error = useAuthStore((s) => s.error)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    try {
      await login(email, password)
      toast.success('Sesión iniciada')
    } catch (e: any) {
      toast.error(e.message || 'No se pudo iniciar sesión')
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5 flex items-center justify-center p-4 relative">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>

      <Card variant="elevated" className="w-full max-w-md overflow-hidden">
        {/* Hero brand */}
        <div className="relative px-8 pt-10 pb-8 text-center bg-gradient-to-br from-primary/10 to-primary/3">
          <img
            src="/aarpia-eagle.png"
            alt="Aarpia"
            className="mx-auto h-16 w-auto object-contain drop-shadow-[0_4px_16px_hsl(var(--primary)/0.25)]"
          />
          <h1 className="mt-4 text-2xl font-bold tracking-tight">Arquitecto</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Diseña y publica aplicaciones de negocio
          </p>
        </div>

        <CardContent className="px-8 pb-8 pt-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Correo electrónico</Label>
              <Input
                id="email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tucorreo@empresa.com"
                className="h-11"
              />
            </div>

            <div className="space-y-1.5">
              <Label htmlFor="password">Contraseña</Label>
              <Input
                id="password"
                type="password"
                required
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-11"
              />
            </div>

            {error && (
              <div className="px-3 py-2 bg-destructive/10 text-destructive rounded-lg text-sm border border-destructive/20">
                {error}
              </div>
            )}

            <Button type="submit" disabled={loading} size="md" className="w-full">
              {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
